"use strict";
/**
 * @module Services.Control
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Codec = require("./../../io/codec");
var serialiser_1 = require("./../../serialisers/serialiser");
/**
 * Serialiser for {@link ChangeAuthorisationRolesFilterRequest}
 */
var ChangeAuthorisationRolesFilterRequestSerialiserClass = /** @class */ (function (_super) {
    __extends(ChangeAuthorisationRolesFilterRequestSerialiserClass, _super);
    function ChangeAuthorisationRolesFilterRequestSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Write a {@link ChangeAuthorisationRolesFilterRequest} to the stream
     *
     * @param bos    the output stream
     * @param value  the {@link ChangeAuthorisationRolesFilterRequest} to be written
     */
    ChangeAuthorisationRolesFilterRequestSerialiserClass.prototype.write = function (bos, value) {
        Codec.writeString(bos, value.filter);
        Codec.writeCollection(bos, value.rolesToRemove, Codec.writeString);
        Codec.writeCollection(bos, value.rolesToAdd, Codec.writeString);
    };
    return ChangeAuthorisationRolesFilterRequestSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.ChangeAuthorisationRolesFilterRequestSerialiserClass = ChangeAuthorisationRolesFilterRequestSerialiserClass;
/**
 * The {@link ChangeAuthorisationRolesFilterRequestSerialiser} singleton
 */ // tslint:disable-next-line:variable-name
exports.ChangeAuthorisationRolesFilterRequestSerialiser = new ChangeAuthorisationRolesFilterRequestSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/control/change-authorisation-roles-filter-request-serialiser.js
// module id = 1184
// module chunks = 1